module.exports = __webpack_public_path__ + "static/img/location.611c24df.png";